import { useTranslation } from "react-i18next";
import { ReactComponent as FullScreen } from "../../shared/fullscreen.svg";
import "./GamePlayer.css";
import { StatsNumbers } from "../StatsNumbers/StatsNumbers";
import { Link } from "react-router-dom";

interface IGame {
  game: string;
}

export default function GamePlayer({ game }: IGame) {
  const { t } = useTranslation();
  const fullScreen = () => {
    const iframe = document.querySelector("iframe");

    if (!iframe) return;

    const requestFullScreen =
      iframe.requestFullscreen ||
      //@ts-ignore
      iframe.mozRequestFullScreen ||
      //@ts-ignore
      iframe.webkitRequestFullscreen ||
      //@ts-ignore
      iframe.msRequestFullscreen;

    // const doc = window.document;
    // //@ts-ignore
    // const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

    requestFullScreen.call(iframe);
  };
  return (
    <div className="gameplayer">
      <StatsNumbers page={game} />
      <div id="gamedemo" className="iframe-wrapper">
        <iframe
          src={
            game === "chicken"
              ? "https://api.flavysofts.com/chicken/demo"
              : game === "mines"
              ? "https://api.flavysofts.com/mines/demo"
              : game === "plinko"
              ? "https://api.flavysofts.com/plinko/demo"
              : game === "towers"
              ? "https://api.flavysofts.com/towers/demo"
              : game === "dice"
              ? "https://api.flavysofts.com/dice/demo"
              : "https://api.flavysofts.com/crash/demo"
          }
          title={
            game === "chicken"
              ? "Chicken Road"
              : game === "mines"
              ? "Mines"
              : game === "plinko"
              ? "Plinko"
              : game === "towers"
              ? "Towers"
              : game === "dice"
              ? "Dice"
              : "Crash"
          }
          allow="fullscreen"
        ></iframe>
      </div>
      <button
        aria-label="Open Fullscreen"
        onClick={fullScreen}
        className="gameplayer-button"
      >
        <FullScreen />
        <p>{t("fullscreen_button")}</p>
      </button>
      <div className="demo-game-selector">
        {!window.location.pathname.includes("chicken") ? (
          <Link to="/chicken" className="demo-game-selector-text">
            Mission Uncrossable
          </Link>
        ) : null}
        {!window.location.pathname.includes("mines") ? (
          <Link to="/mines" className="demo-game-selector-text">
            Mines
          </Link>
        ) : null}
        {!window.location.pathname.includes("plinko") ? (
          <Link to="/plinko" className="demo-game-selector-text">
            Plinko
          </Link>
        ) : null}
        {!window.location.pathname.includes("towers") ? (
          <Link to="/towers" className="demo-game-selector-text">
            Towers
          </Link>
        ) : null}
        {!window.location.pathname.includes("dice") ? (
          <Link to="/dice" className="demo-game-selector-text">
            Dice
          </Link>
        ) : null}
        {!window.location.pathname.includes("crash") ? (
          <Link to="/crash" className="demo-game-selector-text">
            Crash
          </Link>
        ) : null}
      </div>
    </div>
  );
}
